import ResolutionVoteORM from "@/store/orm-axios/models/ResolutionVote";
import MandateORM from "@/store/orm-axios/models/Mandate";

export default {
  methods: {
    CHECK_RULE(resolution, percentType, forOrAgainst, rule, values) {
      let p = percentType;
      let x = forOrAgainst;
      let r = rule;

      let percentFor = 0;
      let percentAgainst = 0;

      // all
      if (r.denominator == this.rulesOptions.denominator.all) {
        if (p == "tantiemes") {
          percentFor = this.getPercentTantiemesFor(resolution);
          percentAgainst = this.getPercentTantiemesAgainst(resolution);
        } else if (p == "votes") {
          percentFor = this.getPercentVotesFor(resolution.id, resolution.voting_category_id);
          percentAgainst = this.getPercentVotesAgainst(
            resolution.id,
            resolution.voting_category_id
          );
        } else if (p == "votes-no-cumul-mandates") {
          // TODO: ??
        }
      }

      // present or represented
      else if (r.denominator == this.rulesOptions.denominator.presentOrRepresented) {
        if (p == "tantiemes") {
          percentFor = this.getPercentTantiemesForPresentOrRepresented(resolution, values);
          percentAgainst = this.getPercentTantiemesAgainstPresentOrRepresented(resolution, values);
        } else if (p == "votes") {
          percentFor = this.getPercentVotesForPresentOrRepresented(resolution.id, values);
          percentAgainst = this.getPercentVotesAgainstPresentOrRepresented(resolution.id, values);
        } else if (p == "votes-no-cumul-mandates") {
          // TODO: ??
        }
      }

      // exprimated
      else if (r.denominator == this.rulesOptions.denominator.exprimated) {
        if (p == "tantiemes") {
          percentFor = this.getPercentTantiemesForExprimated(resolution);
          percentAgainst = this.getPercentTantiemesAgainstExprimated(resolution);
        } else if (p == "votes") {
          percentFor = this.getPercentVotesForExprimated(resolution.id);
          percentAgainst = this.getPercentVotesAgainstExprimated(resolution.id);
        } else if (p == "votes-no-cumul-mandates") {
          // TODO: ??
        }
      }

      // strict present
      else if (r.denominator == this.rulesOptions.denominator.strictPresent) {
        if (p == "tantiemes") {
          percentFor = this.getPercentTantiemesForStrictPresent(resolution, values);
          percentAgainst = this.getPercentTantiemesAgainstStrictPresent(resolution, values);
        } else if (p == "votes") {
          percentFor = this.getPercentVotesForStrictPresent(resolution.id, values);
          percentAgainst = this.getPercentVotesAgainstStrictPresent(resolution.id, values);
        } else if (p == "votes-no-cumul-mandates") {
          // TODO: ??
        }
      }

      // default
      else {
        return false; // ???: ..
      }

      const primaryPercent = x == "for" ? percentFor : percentAgainst;
      const secondaryPercent = x == "for" ? percentAgainst : percentFor;
      const secondaryRuleOperator = this.getSecondaryRuleOperator(r.operators);
      const secondaryRulePercent = this.getSecondaryRulePercent(r.percent);

      const isPassed = eval(`${primaryPercent} ${r.operators} ${r.percent}`);
      const isRejectedWithMajority = eval(
        `${secondaryPercent} ${secondaryRuleOperator} ${secondaryRulePercent}`
      );

      const isRejectedWithLackOfMajority = !isPassed && !isRejectedWithMajority;

      return {
        percent: primaryPercent,
        passed: isPassed,
        lack_of_majority: isRejectedWithLackOfMajority,
      };
    },
    getSecondaryRuleOperator(ruleOperator) {
      var secondaryRuleOperator = "";
      switch (ruleOperator) {
        case ">":
          secondaryRuleOperator = ">=";
          break;
        case "<":
          secondaryRuleOperator = "<=";
          break;
        case ">=":
          secondaryRuleOperator = ">";
          break;
        case "<=":
          secondaryRuleOperator = "<";
          break;
        case "==":
          secondaryRuleOperator = "!=";
          break;
      }

      return secondaryRuleOperator;
    },
    getSecondaryRulePercent(rulePercent) {
      return this.getPercent(100 - rulePercent);
    },

    getPercentTantiemesFor(resolution) {
      var percent =
        (this.getResolutionTantiemesFor(resolution) * 100) /
        this.getResolutionTantiemes(resolution);
      return this.getPercent(percent);
    },
    getPercentTantiemesAgainst(resolution) {
      var percent =
        (this.getResolutionTantiemesAgainst(resolution) * 100) /
        this.getResolutionTantiemes(resolution);
      return this.getPercent(percent);
    },
    getPercentTantiemesForPresentOrRepresented(resolution, values) {
      var percent =
        (this.getResolutionTantiemesFor(resolution) * 100) /
        this.getSumOfTantiemes(
          values.presentTantiemes,
          values.representedTantiemes,
          values.videoTantiemes,
          values.representedVideoTantiemes,
          values.correspondenceTantiemes,
          values.absentButVotedTantiemes
        );
      return this.getPercent(percent);
    },
    getPercentTantiemesAgainstPresentOrRepresented(resolution, values) {
      var percent =
        (this.getResolutionTantiemesAgainst(resolution) * 100) /
        this.getSumOfTantiemes(
          values.presentTantiemes,
          values.representedTantiemes,
          values.videoTantiemes,
          values.representedVideoTantiemes,
          values.correspondenceTantiemes,
          values.absentButVotedTantiemes
        );
      return this.getPercent(percent);
    },
    getPercentTantiemesForExprimated(resolution) {
      var percent =
        (this.getResolutionTantiemesFor(resolution) * 100) /
        this.getResolutionTantiemesExprimated(resolution);
      return this.getPercent(percent);
    },
    getPercentTantiemesAgainstExprimated(resolution) {
      var percent =
        (this.getResolutionTantiemesAgainst(resolution) * 100) /
        this.getResolutionTantiemesExprimated(resolution);
      return this.getPercent(percent);
    },
    getPercentTantiemesForStrictPresent(resolution, values) {
      var percent =
        (this.getResolutionTantiemesForStrictPresent(resolution) * 100) /
        this.getSumOfTantiemes(
          values.presentTantiemes,
          values.videoTantiemes,
          values.correspondenceTantiemes,
          values.absentButVotedInPersonTantiemes
        );
      return this.getPercent(percent);
    },
    getPercentTantiemesAgainstStrictPresent(resolution, values) {
      var percent =
        (this.getResolutionTantiemesAgainstStrictPresent(resolution) * 100) /
        this.getSumOfTantiemes(
          values.presentTantiemes,
          values.videoTantiemes,
          values.correspondenceTantiemes,
          values.absentButVotedInPersonTantiemes
        );
      return this.getPercent(percent);
    },

    getPercentVotesFor(resolutionId, votingCategoryId) {
      var percent =
        (this.getResolutionVotesFor(resolutionId).length * 100) /
        this.getTotalMandatesWithVotingRight(votingCategoryId).length;
      return this.getPercent(percent);
    },
    getPercentVotesAgainst(resolutionId, votingCategoryId) {
      var percent =
        (this.getResolutionVotesAgainst(resolutionId).length * 100) /
        this.getTotalMandatesWithVotingRight(votingCategoryId).length;
      return this.getPercent(percent);
    },
    getPercentVotesForPresentOrRepresented(resolutionId, values) {
      var percent =
        (this.getResolutionVotesFor(resolutionId).length * 100) /
        this.getNumberOfMandates(
          values.presentMandates,
          values.representedMandates,
          values.videoMandates,
          values.representedVideoMandates,
          values.correspondenceMandates,
          values.absentMandatesButVoted
        );
      return this.getPercent(percent);
    },
    getPercentVotesAgainstPresentOrRepresented(resolutionId, values) {
      var percent =
        (this.getResolutionVotesAgainst(resolutionId).length * 100) /
        this.getNumberOfMandates(
          values.presentMandates,
          values.representedMandates,
          values.videoMandates,
          values.representedVideoMandates,
          values.correspondenceMandates,
          values.absentMandatesButVoted
        );
      return this.getPercent(percent);
    },
    getPercentVotesForExprimated(resolutionId) {
      var percent =
        (this.getResolutionVotesFor(resolutionId).length * 100) /
        this.getResolutionVotesExprimated(resolutionId);
      return this.getPercent(percent);
    },
    getPercentVotesAgainstExprimated(resolutionId) {
      var percent =
        (this.getResolutionVotesAgainst(resolutionId).length * 100) /
        this.getResolutionVotesExprimated(resolutionId);
      return this.getPercent(percent);
    },
    getPercentVotesForStrictPresent(resolutionId, values) {
      var percent =
        (this.getResolutionVotesForStrictPresent(resolutionId).length * 100) /
        this.getNumberOfMandates(
          values.presentMandates,
          values.videoMandates,
          values.correspondenceMandates,
          values.absentMandatesButVotedInPerson
        );
      return this.getPercent(percent);
    },
    getPercentVotesAgainstStrictPresent(resolutionId, values) {
      var percent =
        (this.getResolutionVotesAgainstStrictPresent(resolutionId).length * 100) /
        this.getNumberOfMandates(
          values.presentMandates,
          values.videoMandates,
          values.correspondenceMandates,
          values.absentMandatesButVotedInPerson
        );
      return this.getPercent(percent);
    },

    getSumOfTantiemes(...tantiemes) {
      var sum = 0;
      for (const tantieme of tantiemes) {
        sum += tantieme;
      }
      return this.formatNumber(sum);
    },
    getNumberOfMandates(...arraysOfMandates) {
      var total = 0;
      for (const arrayOfMandates of arraysOfMandates) {
        total += arrayOfMandates.length;
      }
      return total;
    },

    getTotalMandates() {
      return MandateORM.getters("getMandatesByMeeting")(this.meeting.id).length;
    },

    getTotalMandatesWithVotingRight(votingCategoryId) {
      var mandates = MandateORM.getters("getMandatesByMeeting")(this.meeting.id);

      return mandates.filter(mandate => {
        const buildingOwnerData = this.findBuildingOwnerDataByMandateId(mandate.id);
        if (buildingOwnerData) {
          if (
            buildingOwnerData.votingRightsByVotingCategory[votingCategoryId] &&
            (buildingOwnerData.votingRightsByVotingCategory[votingCategoryId]
              .reducedMandateTantiemesChargeGenerale ||
              buildingOwnerData.votingRightsByVotingCategory[votingCategoryId].tantiemes)
          ) {
            return mandate;
          }
        } else {
          return mandate;
        }
      });
    },

    getResolutionTantiemes(resolution) {
      return this.getUsedTantiemesByVotingCategory(resolution.voting_category_id);
    },
    getResolutionTantiemesExprimated(resolution) {
      return (
        this.getResolutionTantiemesFor(resolution) + this.getResolutionTantiemesAgainst(resolution)
      );
    },
    getResolutionTantiemesFor(resolution) {
      return this.getUsedVotesTantiemesByVotingCategory(
        this.getResolutionVotesFor(resolution.id),
        resolution.voting_category_id
      );
    },
    getResolutionTantiemesAgainst(resolution) {
      return this.getUsedVotesTantiemesByVotingCategory(
        this.getResolutionVotesAgainst(resolution.id),
        resolution.voting_category_id
      );
    },
    getResolutionTantiemesForStrictPresent(resolution) {
      return this.getUsedVotesTantiemesByVotingCategory(
        this.getResolutionVotesForStrictPresent(resolution.id),
        resolution.voting_category_id
      );
    },
    getResolutionTantiemesAgainstStrictPresent(resolution) {
      return this.getUsedVotesTantiemesByVotingCategory(
        this.getResolutionVotesAgainstStrictPresent(resolution.id),
        resolution.voting_category_id
      );
    },

    getResolutionVotesFor(resolutionId) {
      return this.getResolutionVotes(resolutionId).filter(vote => {
        return vote.vote == this.voteTypes.for;
      });
    },
    getResolutionVotesAgainst(resolutionId) {
      return this.getResolutionVotes(resolutionId).filter(vote => {
        return vote.vote == this.voteTypes.against;
      });
    },
    getResolutionVotesAbstain(resolutionId) {
      return this.getResolutionVotes(resolutionId).filter(vote => {
        return vote.vote == this.voteTypes.abstain;
      });
    },
    getResolutionVotesExprimated(resolutionId) {
      return (
        this.getResolutionVotesFor(resolutionId).length +
        this.getResolutionVotesAgainst(resolutionId).length
      );
    },
    getResolutionVotesForStrictPresent(resolutionId) {
      return this.getResolutionVotes(resolutionId).filter(vote => {
        return (
          vote.vote == this.voteTypes.for &&
          vote.mandate.building_owner_id == vote.mandate.representant_owner_id
        );
      });
    },
    getResolutionVotesAgainstStrictPresent(resolutionId) {
      return this.getResolutionVotes(resolutionId).filter(vote => {
        return (
          vote.vote == this.voteTypes.against &&
          vote.mandate.building_owner_id == vote.mandate.representant_owner_id
        );
      });
    },
    getResolutionVotes(resolutionId) {
      return ResolutionVoteORM.query()
        .where("meeting_has_resolution_id", resolutionId)
        .where(rv => {
          // !!!: ignored_correspondence
          return !rv.ignored_correspondence;
        })
        .with("mandate")
        .get();
    },
  },
};
